import React from "react";
function PregnancyEducationalContent() {
  return (
    <div className="row" style={{ marginTop: "20px" }}>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <strong>ما هي حاسبة الحمل وكيف تعمل؟</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>حاسبة الحمل</strong> هي أداة طبية إلكترونية تساعد السيدات الحوامل على
                تحديد موعد الولادة المتوقع وحساب عمر الحمل بدقة. تعتمد الحاسبة على معادلات طبية
                موثوقة مثل <strong>قاعدة نيغل</strong> (Naegele's Rule) التي يستخدمها الأطباء
                في جميع أنحاء العالم.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                كيف تعمل حاسبة الحمل؟
              </h3>
              <p style={{ lineHeight: "1.8" }}>
                تعمل حاسبة الحمل من خلال الخطوات التالية:
              </p>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>إدخال تاريخ آخر دورة شهرية:</strong> هذا هو التاريخ الذي تبدأ منه السيدة
                  آخر دورة حيض قبل حدوث الحمل.
                </li>
                <li>
                  <strong>تحديد طول الدورة:</strong> المتوسط الطبيعي 28 يوماً، لكن يختلف من سيدة
                  لأخرى (20-45 يوماً).
                </li>
                <li>
                  <strong>حساب موعد الإخصاب:</strong> يحدث عادةً في منتصف الدورة (اليوم 14 قبل
                  الدورة القادمة).
                </li>
                <li>
                  <strong>إضافة 280 يوماً:</strong> هذه هي مدة الحمل الطبيعية (40 أسبوعاً) من
                  أول يوم في آخر دورة.
                </li>
              </ol>
              <div className="alert alert-info mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 قاعدة نيغل الطبية:</strong>
                <br />
                لحساب موعد الولادة المتوقع:
                <br />
                • اطرحي 3 أشهر من تاريخ آخر دورة
                <br />
                • أضيفي 7 أيام
                <br />
                • أضيفي سنة واحدة
                <br/>                <strong>مثال:</strong> آخر دورة كانت في 10 يناير 2024
                <br />
                الحساب: 10 يناير - 3 أشهر + 7 أيام = <strong>17 أكتوبر 2024</strong>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                لماذا نحسب من آخر دورة وليس من يوم الإخصاب؟
              </h3>
              <p style={{ lineHeight: "1.8" }}>
                السبب الطبي هو أن معظم السيدات يتذكرن بدقة موعد آخر دورة شهرية، بينما من الصعب
                تحديد يوم الإخصاب بالضبط. لذلك اتفق الأطباء على استخدام أول يوم من آخر دورة كنقطة
                بداية موحدة لحساب الحمل.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>مراحل الحمل بالتفصيل - الأسابيع والأشهر</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                ينقسم <strong>الحمل</strong> إلى ثلاث مراحل رئيسية تسمى بالثلثات (Trimesters)،
                كل مرحلة لها خصائصها وتطوراتها:
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                الثلث الأول من الحمل (الأسبوع 1 - 13)
              </h3>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>الشهور:</strong> الشهر 1، 2، 3
                <br />
                <strong>المدة:</strong> من الأسبوع 1 حتى نهاية الأسبوع 13
                <br/>                <strong>تطورات الجنين:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>الأسبوع 4-5: ظهور كيس الحمل والنبض في السونار</li>
                  <li>الأسبوع 6-8: تكوّن الأعضاء الأساسية (القلب، الدماغ، الكلى)</li>
                  <li>الأسبوع 9-12: اكتمال معظم الأعضاء، بداية الحركة</li>
                  <li>الأسبوع 13: طول الجنين حوالي 7.5 سم، وزنه 25 جرام</li>
                </ul>
                <br />
                <strong>أعراض شائعة:</strong>
                <ul>
                  <li>غثيان الصباح والقيء</li>
                  <li>تعب وإرهاق شديد</li>
                  <li>تغيرات في الثدي (ألم وتضخم)</li>
                  <li>تقلبات مزاجية</li>
                  <li>كثرة التبول</li>
                </ul>
                <br />
                <strong>فحوصات مهمة:</strong>
                <ul>
                  <li>تحليل الحمل الرقمي (HCG)</li>
                  <li>فحص السونار المهبلي (الأسبوع 6-8)</li>
                  <li>فحص الدم الشامل</li>
                  <li>فحص هرمون الغدة الدرقية</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                الثلث الثاني من الحمل (الأسبوع 14 - 27)
              </h3>
              <div className="alert alert-info" style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}>
                <strong>الشهور:</strong> الشهر 4، 5، 6
                <br />
                <strong>المدة:</strong> من الأسبوع 14 حتى نهاية الأسبوع 27
                <br/>                <strong>تطورات الجنين:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>الأسبوع 14-16: يمكن معرفة جنس الجنين بالسونار</li>
                  <li>الأسبوع 18-20: الأم تبدأ بالشعور بحركة الجنين</li>
                  <li>الأسبوع 22-24: نمو الرئتين، الجنين يسمع الأصوات</li>
                  <li>الأسبوع 27: طول الجنين حوالي 36 سم، وزنه 875 جرام</li>
                </ul>
                <br />
                <strong>أعراض شائعة:</strong>
                <ul>
                  <li>انخفاض الغثيان والتعب</li>
                  <li>زيادة الطاقة والنشاط</li>
                  <li>ظهور البطن بشكل واضح</li>
                  <li>آلام الظهر والحوض</li>
                  <li>حرقة المعدة</li>
                </ul>
                <br />
                <strong>فحوصات مهمة:</strong>
                <ul>
                  <li>سونار تفصيلي (الأسبوع 18-22)</li>
                  <li>فحص سكري الحمل (الأسبوع 24-28)</li>
                  <li>فحص تشوهات الجنين</li>
                  <li>قياس ضغط الدم بانتظام</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                الثلث الثالث من الحمل (الأسبوع 28 - 40)
              </h3>
              <div className="alert alert-warning" style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}>
                <strong>الشهور:</strong> الشهر 7، 8، 9
                <br />
                <strong>المدة:</strong> من الأسبوع 28 حتى الولادة (الأسبوع 37-42)
                <br/>                <strong>تطورات الجنين:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>الأسبوع 28-32: نمو الدماغ السريع، فتح وإغماض العينين</li>
                  <li>الأسبوع 33-36: اكتمال نمو الرئتين</li>
                  <li>الأسبوع 37-40: الجنين كامل النمو وجاهز للولادة</li>
                  <li>الأسبوع 40: طول الجنين حوالي 50 سم، وزنه 3.2-3.6 كجم</li>
                </ul>
                <br />
                <strong>أعراض شائعة:</strong>
                <ul>
                  <li>صعوبة في التنفس بسبب ضغط الجنين</li>
                  <li>تورم القدمين واليدين</li>
                  <li>انقباضات براكستون هيكس (انقباضات كاذبة)</li>
                  <li>كثرة التبول الليلي</li>
                  <li>صعوبة في النوم</li>
                </ul>
                <br />
                <strong>فحوصات مهمة:</strong>
                <ul>
                  <li>متابعة دورية كل أسبوعين ثم أسبوعياً</li>
                  <li>فحص وضعية الجنين بالسونار</li>
                  <li>مراقبة نبض الجنين (CTG)</li>
                  <li>فحص المكورات العقدية من المجموعة ب</li>
                </ul>
              </div>
              <div className="alert alert-danger mt-3" style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}>
                <strong>⚠️ متى تذهبين للمستشفى؟</strong>
                <ul>
                  <li>انقباضات منتظمة كل 5-10 دقائق</li>
                  <li>نزول ماء الرأس (السائل الأمنيوسي)</li>
                  <li>نزيف مهبلي</li>
                  <li>انخفاض حركة الجنين بشكل ملحوظ</li>
                  <li>ألم شديد ومستمر في البطن</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>حساب الحمل بالأسابيع مقابل الأشهر</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                هناك طريقتان شائعتان لحساب عمر الحمل، ولكل منهما فوائدها:
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                حساب الحمل بالأسابيع (الطريقة الطبية)
              </h3>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>المدة الإجمالية:</strong> 40 أسبوعاً (280 يوماً)
                <br/>                <strong>المميزات:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li><strong>أكثر دقة:</strong> الأطباء يستخدمونها لمتابعة نمو الجنين بدقة</li>
                  <li><strong>معايير محددة:</strong> لكل أسبوع معايير طبية واضحة</li>
                  <li><strong>الفحوصات:</strong> مواعيد الفحوصات محددة بالأسابيع</li>
                  <li><strong>عالمية:</strong> نفس النظام في جميع دول العالم</li>
                </ul>
                <br />
                <strong>كيفية الحساب:</strong>
                <br />
                احسبي عدد الأيام من أول يوم في آخر دورة حتى اليوم الحالي، ثم اقسمي على 7.
                <br />
                <strong>مثال:</strong> مرّ 154 يوماً ÷ 7 = <strong>22 أسبوعاً</strong>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                حساب الحمل بالأشهر (الطريقة الشعبية)
              </h3>
              <div className="alert alert-info" style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}>
                <strong>المدة الإجمالية:</strong> 9 أشهر (أو 10 أشهر قمرية)
                <br/>                <strong>المميزات:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li><strong>سهولة الفهم:</strong> أسهل للتذكر والحديث مع الآخرين</li>
                  <li><strong>تقليدية:</strong> الطريقة المعتادة في المجتمع</li>
                  <li><strong>مراحل واضحة:</strong> ثلاثة أثلاث × ثلاثة أشهر</li>
                </ul>
                <br />
                <strong>كيفية الحساب:</strong>
                <br />
                كل 4 أسابيع تقريباً = شهر واحد
                <br />
                <strong>مثال:</strong> 22 أسبوعاً ÷ 4 = <strong>5.5 شهر</strong> (منتصف الشهر السادس)
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                جدول تحويل الأسابيع إلى الأشهر
              </h3>
              <table className="table table-bordered" style={{ width: "100%" }}>
                <thead>
                  <tr style={{ backgroundColor: "#e7f3fe" }}>
                    <th style={{ textAlign: "center", padding: "12px" }}>الشهر</th>
                    <th style={{ textAlign: "center", padding: "12px" }}>الأسابيع</th>
                    <th style={{ textAlign: "center", padding: "12px" }}>المرحلة</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر الأول</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>1 - 4</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الأول</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر الثاني</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>5 - 8</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الأول</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر الثالث</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>9 - 13</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الأول</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر الرابع</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>14 - 17</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الثاني</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر الخامس</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>18 - 22</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الثاني</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر السادس</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>23 - 27</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الثاني</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر السابع</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>28 - 31</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الثالث</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر الثامن</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>32 - 35</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الثالث</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>الشهر التاسع</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>36 - 40</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>الثلث الثالث</td>
                  </tr>
                </tbody>
              </table>
              <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 نصيحة:</strong> استخدمي الأسابيع في المتابعة الطبية والأشهر في
                الحديث مع العائلة والأصدقاء. كلاهما صحيح!
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>نصائح مهمة خلال فترة الحمل</strong>
            </div>
            <div className="info-section-body">
              <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                التغذية السليمة للحامل:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>حمض الفوليك:</strong> 400-800 ميكروجرام يومياً لمنع التشوهات
                </li>
                <li>
                  <strong>الكالسيوم:</strong> 1000 ملجم يومياً لصحة العظام
                </li>
                <li>
                  <strong>الحديد:</strong> 27 ملجم يومياً لمنع فقر الدم
                </li>
                <li>
                  <strong>البروتين:</strong> 70-100 جرام يومياً من اللحوم والبقوليات
                </li>
                <li>
                  <strong>الماء:</strong> 8-10 أكواب يومياً للترطيب
                </li>
              </ul>
              <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                الأطعمة التي يجب تجنبها:
              </h3>
              <div className="alert alert-danger" style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}>
                <ul>
                  <li>الأسماك الغنية بالزئبق (التونة، سمك أبو سيف)</li>
                  <li>اللحوم والأجبان غير المطبوخة جيداً</li>
                  <li>البيض النيء أو نصف المطبوخ</li>
                  <li>الكافيين الزائد (أكثر من 200 ملجم يومياً)</li>
                  <li>الكحول تماماً</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                النشاط البدني والرياضة:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>المشي:</strong> 30 دقيقة يومياً من أفضل التمارين
                </li>
                <li>
                  <strong>السباحة:</strong> آمنة ومفيدة لتخفيف الضغط
                </li>
                <li>
                  <strong>اليوجا للحوامل:</strong> تحسن المرونة وتقلل التوتر
                </li>
                <li>
                  <strong>تمارين كيجل:</strong> لتقوية عضلات الحوض
                </li>
              </ul>
              <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8" }}>
                <strong>⚠️ تجنبي:</strong> الرياضات العنيفة، رفع الأثقال الثقيلة، التمارين التي
                تتطلب الاستلقاء على الظهر بعد الشهر الرابع.
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                العناية بالصحة النفسية:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>خذي قسطاً كافياً من الراحة والنوم (7-9 ساعات)</li>
                <li>مارسي تقنيات الاسترخاء والتأمل</li>
                <li>تحدثي عن مشاعرك مع الشريك أو مختص</li>
                <li>انضمي لمجموعات دعم الحوامل</li>
                <li>تجنبي التوتر والضغط النفسي قدر الإمكان</li>
              </ul>
              <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                المتابعة الطبية المنتظمة:
              </h3>
              <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                <strong>جدول الزيارات الموصى به:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>الأسابيع 4-28: زيارة كل 4 أسابيع</li>
                  <li>الأسابيع 28-36: زيارة كل 2-3 أسابيع</li>
                  <li>الأسابيع 36-40: زيارة أسبوعية</li>
                </ul>
              </div>
              <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                <strong>✓ نصيحة ذهبية:</strong> استمعي لجسمك دائماً. إذا شعرتِ بأي شيء غير
                طبيعي، لا تترددي في الاتصال بطبيبك مهما كان الوقت. صحتك وصحة طفلك أهم من أي شيء!
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>التحضير للولادة - دليل شامل</strong>
            </div>
            <div className="info-section-body">
              <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                أنواع الولادة:
              </h3>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>1. الولادة الطبيعية (المهبلية):</strong>
              </h4>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>المميزات:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>تعافي أسرع بعد الولادة</li>
                  <li>إقامة أقصر في المستشفى (1-2 يوم)</li>
                  <li>مخاطر أقل للعدوى</li>
                  <li>الطفل يستفيد من البكتيريا النافعة في قناة الولادة</li>
                </ul>
                <br />
                <strong>متى تُنصح بها:</strong>
                <ul>
                  <li>حمل طبيعي بدون مضاعفات</li>
                  <li>وضعية الجنين طبيعية (الرأس للأسفل)</li>
                  <li>عدم وجود مشاكل صحية تمنع الولادة الطبيعية</li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>2. الولادة القيصرية:</strong>
              </h4>
              <div className="alert alert-info" style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}>
                <strong>متى تكون ضرورية:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>وضعية الجنين غير طبيعية (مقعدي أو عرضي)</li>
                  <li>المشيمة تسد عنق الرحم (المشيمة المنزاحة)</li>
                  <li>تعثر الولادة الطبيعية أو معاناة الجنين</li>
                  <li>حمل توأم أو أكثر</li>
                  <li>مشاكل صحية لدى الأم (ضغط عالي، سكري حاد)</li>
                  <li>قيصريات سابقة متعددة</li>
                </ul>
                <br />
                <strong>فترة التعافي:</strong>
                <ul>
                  <li>إقامة في المستشفى 3-4 أيام</li>
                  <li>تعافي كامل خلال 6-8 أسابيع</li>
                  <li>يمكن العودة للنشاطات الخفيفة بعد أسبوعين</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                حقيبة المستشفى - ماذا تجهزين؟
              </h3>
              <div className="alert alert-warning" style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}>
                <strong>للأم:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>ملابس داخلية قطنية واسعة (5-6 قطع)</li>
                  <li>فوط صحية للنفاس (عبوتين كبيرتين)</li>
                  <li>قميص نوم للرضاعة (2-3 قطع)</li>
                  <li>حمالة صدر للرضاعة</li>
                  <li>شبشب مريح</li>
                  <li>مستلزمات النظافة الشخصية</li>
                  <li>الأوراق الثبوتية والطبية</li>
                </ul>
                <br />
                <strong>للمولود:</strong>
                <ul>
                  <li>ملابس قطنية (3-4 أطقم مقاس حديث ولادة)</li>
                  <li>قفازات وجوارب</li>
                  <li>قبعة صغيرة</li>
                  <li>بطانية خفيفة</li>
                  <li>حفاضات حديثي الولادة (عبوة صغيرة)</li>
                  <li>مناديل مبللة خاصة بالأطفال</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                علامات قرب الولادة:
              </h3>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>نزول الجنين للحوض:</strong> قد يحدث قبل أسابيع من الولادة
                </li>
                <li>
                  <strong>السدادة المخاطية:</strong> خروج إفرازات مخاطية وردية اللون
                </li>
                <li>
                  <strong>توسع عنق الرحم:</strong> يفحصه الطبيب في الزيارات الأخيرة
                </li>
                <li>
                  <strong>الانقباضات المنتظمة:</strong> كل 5-10 دقائق وتزداد شدة
                </li>
                <li>
                  <strong>نزول ماء الرأس:</strong> تدفق سائل من المهبل
                </li>
              </ol>
              <div className="alert alert-danger mt-3" style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}>
                <strong>⚠️ اذهبي للمستشفى فوراً إذا:</strong>
                <ul>
                  <li>نزل ماء الرأس (حتى بدون انقباضات)</li>
                  <li>انقباضات منتظمة كل 5 دقائق لمدة ساعة</li>
                  <li>نزيف مهبلي شديد</li>
                  <li>ألم حاد ومستمر في البطن</li>
                  <li>توقف أو انخفاض ملحوظ في حركة الجنين</li>
                  <li>صداع شديد مع تشوش في الرؤية</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                بعد الولادة - ماذا تتوقعين؟
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>النزيف النفاسي:</strong> طبيعي ويستمر 4-6 أسابيع
                </li>
                <li>
                  <strong>الرضاعة الطبيعية:</strong> ابدئي خلال الساعة الأولى من الولادة
                </li>
                <li>
                  <strong>تقلصات الرحم:</strong> طبيعية وتساعد الرحم على العودة لحجمه
                </li>
                <li>
                  <strong>التعب والإرهاق:</strong> خذي راحة كافية واطلبي المساعدة
                </li>
                <li>
                  <strong>الكآبة النفاسية:</strong> شائعة في الأيام الأولى، استشيري طبيبك إذا استمرت
                </li>
              </ul>
            </div>
          </div>
        </div>
        <br />
        {/* FAQ Section */}
        <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
          أسئلة متكررة حول حاسبة الحمل
        </h2>
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيف أحسب موعد الولادة بدقة؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                لحساب <strong>موعد الولادة</strong> بدقة، اتبعي الخطوات التالية:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الطريقة الأولى: قاعدة نيغل (الأكثر استخداماً)</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>حددي تاريخ أول يوم في آخر دورة شهرية</li>
                <li>اطرحي 3 أشهر من هذا التاريخ</li>
                <li>أضيفي 7 أيام</li>
                <li>أضيفي سنة واحدة</li>
              </ol>
              <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                <strong>مثال عملي:</strong>
                <br />
                آخر دورة: 15 مارس 2024
                <br />
                - 3 أشهر = 15 ديسمبر 2023
                <br />
                + 7 أيام = 22 ديسمبر 2023
                <br />
                + سنة = <strong>22 ديسمبر 2024</strong>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الطريقة الثانية: إضافة 280 يوماً</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                ببساطة، أضيفي 280 يوماً (40 أسبوعاً) إلى تاريخ أول يوم في آخر دورة.
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الطريقة الثالثة: حاسبة الحمل الإلكترونية</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                استخدمي <strong>حاسبة الحمل</strong> في أعلى الصفحة للحصول على النتيجة فوراً
                مع معلومات إضافية عن مراحل الحمل.
              </p>
              <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8" }}>
                <strong>⚠️ ملاحظة:</strong> هذه التواريخ تقديرية. للحصول على موعد أدق، يجب
                زيارة الطبيب وإجراء فحص السونار في الأسابيع الأولى (6-12 أسبوع).
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما هي مدة الحمل الطبيعية؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>مدة الحمل الطبيعية</strong> تختلف من امرأة لأخرى، لكن هناك معايير طبية
                واضحة:
              </p>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>الفترة الطبيعية الكاملة:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li><strong>المتوسط:</strong> 40 أسبوعاً (280 يوماً)</li>
                  <li><strong>النطاق الطبيعي:</strong> 37 - 42 أسبوعاً</li>
                  <li><strong>الأمثل:</strong> 39 - 40 أسبوعاً</li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>تصنيف الولادات حسب التوقيت:</strong>
              </h4>
              <table className="table table-bordered" style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ padding: "12px" }}>
                      <strong>ولادة مبكرة جداً</strong>
                    </td>
                    <td style={{ padding: "12px" }}>
                      قبل الأسبوع 28
                    </td>
                    <td style={{ padding: "12px", backgroundColor: "#f8d7da" }}>
                      تتطلب رعاية مركزة
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px" }}>
                      <strong>ولادة مبكرة</strong>
                    </td>
                    <td style={{ padding: "12px" }}>
                      الأسبوع 28 - 36
                    </td>
                    <td style={{ padding: "12px", backgroundColor: "#fff3cd" }}>
                      قد تحتاج رعاية خاصة
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px" }}>
                      <strong>ولادة في الموعد</strong>
                    </td>
                    <td style={{ padding: "12px" }}>
                      الأسبوع 37 - 42
                    </td>
                    <td style={{ padding: "12px", backgroundColor: "#d4edda" }}>
                      طبيعية وآمنة
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px" }}>
                      <strong>ولادة متأخرة</strong>
                    </td>
                    <td style={{ padding: "12px" }}>
                      بعد الأسبوع 42
                    </td>
                    <td style={{ padding: "12px", backgroundColor: "#fff3cd" }}>
                      تتطلب متابعة دقيقة
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>حقائق مهمة:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>فقط 5% من النساء يلدن في الموعد المحدد بالضبط</li>
                <li>60% يلدن خلال أسبوع من الموعد المتوقع</li>
                <li>90% يلدن خلال أسبوعين من الموعد المتوقع</li>
                <li>الحمل الأول عادةً يستغرق وقتاً أطول من الحمل الثاني</li>
              </ul>
              <div className="alert alert-info mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 معلومة طبية:</strong> الجنين يُعتبر مكتمل النمو بعد إتمام 37 أسبوعاً،
                لكن البقاء في الرحم حتى 39-40 أسبوعاً يعطي فوائد إضافية لنمو الدماغ والرئتين.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيف أعرف في أي أسبوع من الحمل أنا؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                لمعرفة <strong>أسبوع الحمل الحالي</strong>، هناك عدة طرق دقيقة:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الطريقة الأولى: الحساب اليدوي</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>حددي تاريخ أول يوم في آخر دورة شهرية</li>
                <li>احسبي عدد الأيام من ذلك التاريخ حتى اليوم</li>
                <li>اقسمي الناتج على 7 (عدد أيام الأسبوع)</li>
                <li>الناتج هو عدد الأسابيع، والباقي هو عدد الأيام الإضافية</li>
              </ol>
              <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                <strong>مثال:</strong>
                <br />
                آخر دورة: 1 نوفمبر 2024
                <br />
                اليوم: 17 يناير 2025
                <br />
                عدد الأيام: 77 يوماً
                <br />
                77 ÷ 7 = 11 أسبوعاً بالإضافة إلى يومين
                <br />
                <strong>النتيجة: أنتِ في الأسبوع 11 + 2</strong>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الطريقة الثانية: حاسبة الحمل الإلكترونية</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                استخدمي <strong>حاسبة الحمل</strong> في أعلى الصفحة. ما عليكِ سوى إدخال تاريخ
                آخر دورة، وستحصلين فوراً على:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li>عمر الحمل بالأسابيع والأيام</li>
                <li>عمر الحمل بالأشهر</li>
                <li>المرحلة الحالية (ثلث أول، ثاني، ثالث)</li>
                <li>موعد الولادة المتوقع</li>
                <li>المدة المتبقية حتى الولادة</li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الطريقة الثالثة: فحص السونار (الأدق)</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                فحص السونار في الأسابيع الأولى (6-12 أسبوع) هو الطريقة الأدق لتحديد عمر الحمل،
                حيث يقيس الطبيب:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li><strong>CRL:</strong> طول الجنين من الرأس إلى المؤخرة (في الثلث الأول)</li>
                <li><strong>BPD:</strong> قطر رأس الجنين (في الثلث الثاني والثالث)</li>
                <li><strong>FL:</strong> طول عظم الفخذ</li>
                <li><strong>AC:</strong> محيط البطن</li>
              </ul>
              <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                <strong>✓ نصيحة:</strong> إذا كانت دورتك غير منتظمة أو لا تتذكرين موعد آخر دورة
                بدقة، فإن فحص السونار المبكر هو الطريقة الأمثل لتحديد عمر الحمل بدقة.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما الفرق بين حساب الحمل بالأسابيع والأشهر؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                هناك فرق واضح بين الطريقتين، ولكل منهما استخداماتها:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>حساب الحمل بالأسابيع:</strong>
              </h4>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>المميزات:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li><strong>أكثر دقة طبياً:</strong> كل يوم في الحمل مهم لنمو الجنين</li>
                  <li><strong>معايير واضحة:</strong> كل أسبوع له معايير نمو محددة</li>
                  <li><strong>جدولة الفحوصات:</strong> مواعيد السونار والتحاليل محددة بالأسابيع</li>
                  <li><strong>عالمية:</strong> نفس النظام في جميع المستشفيات</li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>حساب الحمل بالأشهر:</strong>
              </h4>
              <div className="alert alert-info" style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}>
                <strong>المميزات:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li><strong>سهولة الفهم:</strong> أسهل للتذكر والحديث مع الآخرين</li>
                  <li><strong>مألوفة اجتماعياً:</strong> الناس يفهمون "الشهر الخامس" أكثر</li>
                  <li><strong>مراحل واضحة:</strong> ثلاث مراحل × ثلاثة أشهر</li>
                </ul>
              </div>
              <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 ملاحظة مهمة:</strong> الشهر الطبي يساوي 4 أسابيع بالضبط (28 يوماً)،
                وليس شهر ميلادي عادي (30-31 يوم). لذلك الحمل 9 أشهر طبية = 40 أسبوعاً.
              </div>
              <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                <strong>✓ النصيحة الذهبية:</strong> استخدمي الأسابيع في المتابعة الطبية لأنها
                الأدق، واستخدمي الأشهر في الحديث الاجتماعي لأنها الأسهل!
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                هل حاسبة الحمل دقيقة؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>دقة حاسبة الحمل</strong> تعتمد على عدة عوامل. إليكِ التفاصيل:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>متى تكون حاسبة الحمل دقيقة؟</strong>
              </h4>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>الحاسبة تكون دقيقة جداً (±5 أيام) إذا:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>✓ كانت دورتك الشهرية منتظمة (تأتي كل 28 يوماً بانتظام)</li>
                  <li>✓ تتذكرين بدقة تاريخ أول يوم في آخر دورة</li>
                  <li>✓ لم تكوني تستخدمين حبوب منع الحمل مؤخراً</li>
                  <li>✓ حدث الحمل طبيعياً (بدون تلقيح صناعي)</li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>متى تكون حاسبة الحمل أقل دقة؟</strong>
              </h4>
              <div className="alert alert-warning" style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}>
                <strong>الحاسبة قد تكون أقل دقة (±10-14 يوماً) إذا:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>دورتك الشهرية غير منتظمة</li>
                  <li>طول دورتك يختلف كثيراً</li>
                  <li>لا تتذكرين بدقة تاريخ آخر دورة</li>
                  <li>حدث الحمل بعد التوقف عن حبوب منع الحمل مباشرة</li>
                </ul>
              </div>
              <div className="alert alert-info mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 حقيقة طبية:</strong> فقط 5% من النساء يلدن في الموعد المحدد بالضبط.
                معظم الولادات (90%) تحدث في نطاق أسبوعين قبل أو بعد الموعد المتوقع. هذا طبيعي
                تماماً ولا يدعو للقلق.
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>نصائح لزيادة الدقة:</strong>
              </h4>
              <div className="alert alert-success" style={{ lineHeight: "1.8" }}>
                <ul>
                  <li>استخدمي حاسبة الحمل كتقدير أولي</li>
                  <li>أجري فحص السونار المبكر (الأسبوع 8-12) للتأكيد</li>
                  <li>إذا اختلف السونار عن الحاسبة بأكثر من أسبوع، اعتمدي على السونار</li>
                  <li>تابعي مع طبيبك بانتظام لمراقبة نمو الجنين</li>
                  <li>لا تقلقي إذا تأخرت أو تقدمت الولادة بأيام قليلة</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PregnancyEducationalContent;